(function () {
  'use strict';

  var dialog = document.getElementById('pdp-fit-checker');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-fit-checker-open]'));
  var form = dialog.querySelector('[data-pfc-form]');
  var steps = Array.prototype.slice.call(dialog.querySelectorAll('[data-pfc-step]'));
  var progress = Array.prototype.slice.call(dialog.querySelectorAll('[data-pfc-progress]'));
  var body = dialog.querySelector('.pfc__body');
  var backButton = dialog.querySelector('[data-pfc-back]');
  var nextButton = dialog.querySelector('[data-pfc-next]');
  var closeButton = dialog.querySelector('[data-pfc-close]');
  var result = dialog.querySelector('.pfc__result');
  var resultMark = dialog.querySelector('[data-pfc-result-mark]');
  var resultTitle = dialog.querySelector('[data-pfc-result-title]');
  var resultCopy = dialog.querySelector('[data-pfc-result-copy]');
  var comparison = dialog.querySelector('[data-pfc-comparison]');
  var currentStep = 0;
  var correctionStep = 0;
  var lastTrigger = null;

  var product = {
    title: dialog.getAttribute('data-product-title') || 'This product',
    sku: dialog.getAttribute('data-product-sku') || '',
    type: dialog.getAttribute('data-product-type') || '',
    typeLabel: dialog.getAttribute('data-product-type-label') || '',
    diameter: numberOrNull(dialog.getAttribute('data-product-dia')),
    diameterLabel: dialog.getAttribute('data-product-dia-label') || '',
    edge: dialog.getAttribute('data-product-edge') || '',
    edgeLabel: dialog.getAttribute('data-product-edge-label') || '',
    housing: numberOrNull(dialog.getAttribute('data-product-housing')),
    housingLabel: dialog.getAttribute('data-product-housing-label') || '',
    tab: dialog.getAttribute('data-product-tab') || '',
    tabLabel: dialog.getAttribute('data-product-tab-label') || ''
  };

  function numberOrNull(value) {
    if (value === null || value === '') return null;
    var parsed = parseFloat(value);
    return isNaN(parsed) ? null : parsed;
  }

  function checkedValue(name) {
    var checked = form.querySelector('input[name="' + name + '"]:checked');
    return checked ? checked.value : null;
  }

  function selectValue(selector) {
    var select = dialog.querySelector(selector);
    return select ? select.value : '';
  }

  function selectedLabel(selector, fallback) {
    var select = dialog.querySelector(selector);
    if (!select || !select.value) return fallback || 'Not entered';
    return select.options[select.selectedIndex].text.replace(/\s+\([^)]+\)$/, '');
  }

  function typeLabel(value) {
    if (value === 'single') return 'Single wheel';
    if (value === 'tandem') return 'Tandem / dual';
    return 'Not entered';
  }

  function edgeLabel(value) {
    if (value === 'Concave/Grooved') return 'Concave / grooved';
    if (value === 'Flat') return 'Flat';
    return 'Not sure';
  }

  function setError(step, show) {
    var error = dialog.querySelector('[data-pfc-error="' + step + '"]');
    if (!error) return;
    error.hidden = !show;
    if (show) error.focus();
  }

  function validateStep(step) {
    if (step === 0) {
      var hasType = checkedValue('pfc-type') !== null;
      setError(0, !hasType);
      return hasType;
    }

    if (step === 1) {
      var hasDiameter = selectValue('[data-pfc-wheel-dia]') !== '';
      setError(1, !hasDiameter);
      return hasDiameter;
    }

    if (step === 2 && product.tab) {
      var hasTabAnswer = checkedValue('pfc-tab-match') !== null;
      setError(2, !hasTabAnswer);
      return hasTabAnswer;
    }

    return true;
  }

  function focusStep(step) {
    window.requestAnimationFrame(function () {
      var panel = steps[step];
      if (!panel) return;
      var target = panel.querySelector('input:checked, select, input, a[href], button');
      if (target) target.focus();
      if (body) body.scrollTop = 0;
    });
  }

  function showStep(step, focus) {
    currentStep = step;

    steps.forEach(function (panel, index) {
      var active = index === step;
      panel.hidden = !active;
      panel.classList.toggle('is-current', active);
    });

    progress.forEach(function (item, index) {
      item.classList.toggle('is-current', step < 3 && index === step);
      item.classList.toggle('is-complete', step >= 3 || index < step);
      if (step < 3 && index === step) item.setAttribute('aria-current', 'step');
      else item.removeAttribute('aria-current');
    });

    backButton.hidden = step === 0;
    nextButton.hidden = step === 3;
    backButton.textContent = step === 3 ? 'Check measurements again' : 'Back';
    nextButton.textContent = step === 2 ? 'Compare' : 'Continue';

    if (focus !== false) focusStep(step);
  }

  function addComparisonRow(item) {
    var row = document.createElement('li');
    row.className = 'is-' + item.status;

    var field = document.createElement('strong');
    field.textContent = item.field;

    var shopper = document.createElement('span');
    shopper.textContent = 'Your roller: ' + item.user;

    var target = document.createElement('span');
    target.textContent = 'This product: ' + item.target;

    row.appendChild(field);
    row.appendChild(shopper);
    row.appendChild(target);
    comparison.appendChild(row);
  }

  function compareText(field, user, target, matches, step, unknown) {
    return {
      field: field,
      user: user,
      target: target,
      status: unknown ? 'unknown' : (matches ? 'match' : 'mismatch'),
      step: step
    };
  }

  function compareNumber(field, userValue, userLabel, targetValue, targetLabel, step) {
    if (targetValue === null) {
      return compareText(field, userLabel, 'Not recorded', false, step, true);
    }
    if (userValue === null) {
      return compareText(field, 'Not entered', targetLabel, false, step, true);
    }
    return compareText(field, userLabel, targetLabel, Math.abs(userValue - targetValue) < 0.011, step, false);
  }

  function renderResult() {
    var userType = checkedValue('pfc-type') || '';
    var userEdge = checkedValue('pfc-edge');
    var userDiameter = numberOrNull(selectValue('[data-pfc-wheel-dia]'));
    var userHousing = numberOrNull(selectValue('[data-pfc-housing-width]'));
    var tabMatch = checkedValue('pfc-tab-match');
    var rows = [];

    rows.push(compareText('Wheel count', typeLabel(userType), product.typeLabel || 'Not recorded', userType === product.type, 0, !product.type));
    rows.push(compareNumber(
      'Wheel diameter',
      userDiameter,
      selectedLabel('[data-pfc-wheel-dia]'),
      product.diameter,
      product.diameterLabel || 'Not recorded',
      1
    ));

    if (product.edge) {
      rows.push(compareText(
        'Wheel edge',
        edgeLabel(userEdge),
        product.edgeLabel || edgeLabel(product.edge),
        userEdge === product.edge,
        0,
        userEdge === null || userEdge === ''
      ));
    } else {
      rows.push(compareText('Wheel edge', edgeLabel(userEdge), 'Not recorded', false, 0, true));
    }

    rows.push(compareNumber(
      'Housing width',
      userHousing,
      selectedLabel('[data-pfc-housing-width]'),
      product.housing,
      product.housingLabel || 'Not recorded',
      1
    ));

    if (product.tab) {
      rows.push(compareText(
        'Mounting style',
        tabMatch === 'yes' ? 'Matches' : (tabMatch === 'no' ? 'Different' : 'Not sure'),
        product.tabLabel,
        tabMatch === 'yes',
        2,
        tabMatch === 'unsure'
      ));
    } else {
      rows.push(compareText('Mounting style', 'Not checked', 'Not recorded', false, 2, true));
    }

    var mismatches = rows.filter(function (item) { return item.status === 'mismatch'; });
    var unknowns = rows.filter(function (item) { return item.status === 'unknown'; });
    comparison.innerHTML = '';
    rows.forEach(addComparisonRow);

    result.classList.remove('is-match', 'is-mismatch', 'is-partial');

    if (mismatches.length) {
      result.classList.add('is-mismatch');
      resultMark.textContent = '!';
      resultTitle.textContent = 'These measurements do not match';
      resultCopy.textContent = 'Double-check the highlighted differences and enter your measurements again. A wrong measurement can make the correct roller look incompatible.';
      correctionStep = mismatches.reduce(function (lowest, item) {
        return Math.min(lowest, item.step);
      }, 2);
    } else if (unknowns.length) {
      result.classList.add('is-partial');
      resultMark.textContent = '?';
      resultTitle.textContent = 'Available measurements match';
      resultCopy.textContent = 'Nothing entered conflicts with this roller, but one or more details are unknown. Confirm the flagged details before ordering.';
      var actionableUnknowns = unknowns.filter(function (item) {
        return item.user === 'Not entered' || item.user === 'Not sure';
      });
      correctionStep = actionableUnknowns.length ? actionableUnknowns[0].step : 0;
    } else {
      result.classList.add('is-match');
      resultMark.textContent = '✓';
      resultTitle.textContent = 'Measurements match this roller';
      resultCopy.textContent = 'The wheel setup, dimensions, edge, and mounting style you entered match the recorded specifications for this product.';
      correctionStep = 0;
    }

    showStep(3);

    if (window.PDPAnalytics && typeof window.PDPAnalytics.track === 'function') {
      window.PDPAnalytics.track('fit_checker_result', {
        sku: product.sku,
        status: mismatches.length ? 'mismatch' : (unknowns.length ? 'partial' : 'match')
      });
    }
  }

  function openChecker(trigger) {
    lastTrigger = trigger;
    showStep(0, false);
    dialog.showModal();
    document.body.classList.add('pfc-open');
    focusStep(0);

    if (window.PDPAnalytics && typeof window.PDPAnalytics.track === 'function') {
      window.PDPAnalytics.track('fit_checker_open', { sku: product.sku });
    }
  }

  function closeChecker() {
    if (dialog.open) dialog.close();
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openChecker(trigger);
    });
  });

  closeButton.addEventListener('click', closeChecker);

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) closeChecker();
  });

  dialog.addEventListener('close', function () {
    document.body.classList.remove('pfc-open');
    window.requestAnimationFrame(function () {
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    });
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!validateStep(currentStep)) return;
    if (currentStep < 2) showStep(currentStep + 1);
    else if (currentStep === 2) renderResult();
  });

  backButton.addEventListener('click', function () {
    if (currentStep === 3) showStep(correctionStep);
    else if (currentStep > 0) showStep(currentStep - 1);
  });

  form.addEventListener('change', function (event) {
    var error = event.target.closest('[data-pfc-step]');
    if (!error) return;
    var step = parseInt(error.getAttribute('data-pfc-step'), 10);
    setError(step, false);
  });
})();
